<template>
	<div class="home">
		<div class="headTab">
			<span @click="changeIsSales(1)" :class="isSales ? 'active' : '' ">销量</span>
			<span @click="changeIsSales(2)" :class="isSales ? '' : 'active' ">离我最近</span>
		</div>
		<div class="ProductList height2" v-if="isRouterAlive">
			<ProductList :typeName="typeMes"></ProductList>
			
			
		</div>

		<FootTab></FootTab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import ProductList from "@/components/ProductList.vue";
	import FootTab from "@/components/FootTab.vue";
	export default {
		name: "productFilter",
		components: {
			FootTab,
			ProductList
		},
		data() {
			return {
				"hasHead": false,
				"typeMes": {
					"name":"免预约",
					"type":1	//1销量，2离我最近
				},

				classifyArr: [{
					"name": "美食餐饮"
				}, {
					"name": "休闲娱乐"
				}, {
					"name": "丽人美发"
				}, {
					"name": "生活服务"
				}, {
					"name": "亲子玩乐"
				}, {
					"name": "酒店门票"
				}, {
					"name": "享吃龙虾"
				}, {
					"name": "品牌优选"
				}],

				"isRouterAlive": true,
				"isSales":true
			}
		},
		activated() {

		},
		created() {

		},
		mounted() {
			var that = this;
			
			
			if (that.$route.query.hasHead == 'false') {
				that.hasHead = false;
			} else{
				that.hasHead = true;
			}
		},
		methods: {
			defImg() { // 图片加载失败时加载占位图
				let img = event.srcElement;
				img.src = this.defaultImg;
				img.onerror = null; //防止闪图
			},
			changeIsSales(type){
				this.typeMes.type = type;
				
				if (type == 1) {
					this.isSales = true;
				} else{
					this.isSales = false;
				}
				this.reload();
			},
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(() => (this.isRouterAlive = true));
			}
		}

	};
</script>

<style scoped lang="scss">
	.home {
		height: 100vh;
		overflow: auto;
		padding-bottom: 1.6rem;
		padding-top: 0.3rem;

		.headTab{
			text-align: left;
			padding-bottom: 0.3rem;
			padding-left: 0.5rem;
			box-shadow: 0px 2px 3px rgba(0,0,0,0.1);
			
			span{
				display: inline-block;
				vertical-align: middle;
				margin-left: 1rem;
				font-size: 0.32rem;
				color: #333333;
				font-weight: bold;
			}
			
			span.active{
				color: #fb8a17;
			}
			
			span:first-child{
				margin-left: 0;
			}
		}

		.ProductList {
			padding: 0px 0.2rem 0px 0.3rem;
		}


		.ProductList.height1 {
			height: calc(100vh - 1.7rem);
		}

		.ProductList.height2 {
			height: calc(100vh - 1.7rem);
		}

	}
</style>
